import React from 'react';
import AdminLayout from '../../../components/Layout/AdminLayout';
import NewsletterManager from '../../../components/siteadmin/NewsletterManager/NewsletterManager';

export default async function action() {
  return {
    title: 'Boletin - NAVEGA Admin',
    component: (
      <AdminLayout>
        <NewsletterManager />
      </AdminLayout>
    )
  };
}
